<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-row>
      <v-col cols="12" class="text-center mt-4 ">
        <h3 class="text-center kbDarkBlueText--text" >{{ $t('general.youAreAlmostDone') }}</h3>
        <span class="kbDarkBlueText--text"
              v-if="selectedList.totalUsers>0">
            {{ $t('general.yourMessageScope', { numberOfPeople: selectedList.totalUsers }) }}
        </span>
      </v-col>

      <email-data v-if="campaignType === 'email'" :email="email" />

      <sms-data v-if="campaignType === 'sms'" :sms="sms"/>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn color="kbGrayText"
               outlined
               @click="updateStep(2)"
               class="float-left">
          <v-icon dark>keyboard_arrow_left</v-icon>
          <span class="hidden-xs-only kbGrayText--text">{{ $t('general.goBack') }}</span>
        </v-btn>
        <v-btn :loading="loading"
               color="kbPurple"
               dark
               class="float-right"
               @click="campaignType === 'email' ? updateStep(4) : createCampaign()">
          <span class="hidden-xs-only">
            {{ campaignType === 'email' ? $t('general.continue') : $t('general.prepareCampaign') }}
          </span>
          <v-icon dark
                  right
                  v-if="campaignType !== 'email'">
            check
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import notifications from '@/libs/notifications'
import EmailData from '@/pages/App/Communications/Email/EmailData.vue'
import SmsData from '@/pages/App/Communications/Sms/SmsData.vue'
import rules from '@/libs/rules'
export default {
  components: { EmailData, SmsData },
  data () {
    return {
      loading: false,
      sms: {
        message: ''
      },
      persons: 3548,
      actualPerson: 0,
      processPercent: 0
    }
  },
  methods: {
    updateStep (step) {
      if (step === 4 && rules.required(this.email.subject) !== true) {
        return notifications.error(this.$t('general.insertMessageSubject'))
      }
      this.$emit('updateStep', step)
    },
    async createCampaign () {
      this.loading = true
      const body = { sms: this.sms }
      const data = {
        date: new Date().toISOString(),
        name: this.campaignName,
        ...body,
        type: this.campaignType
      }
      // verificamos si todas las personas esta seleccionado en la lista
      if (this.selectedList._id !== 'all') data.listId = this.selectedList._id

      try {
        const response = await this.$store.dispatch('createCampaign', data)
        const responseCreateList = await this.$store.dispatch('createCampaignUserList', {
          campaignId: response.campaign._id,
          createFromUser: this.selectedList._id === 'all'
        })
        this.$router.push(`/apps/${this.$store.getters.appUuid}/campaigns/${response.campaign._id}`)
        notifications.success(responseCreateList.message)
        this.loading = false
      } catch (e) {
        notifications.error(e.message)
        this.loading = false
      }
    }
  },
  props: ['campaignName', 'selectedList', 'campaignType', 'email']
}
</script>
